import type { Maintenance } from './models/maintenance.model';

export const maintenances: readonly Maintenance[] = [
  {
    title: 'Planlagt vedlikehold',
    body: 'Kartet er midlertidig utilgjengelig.',
    startDate: new Date('2026-09-16T12:00:00+02:00'),
    endDate: new Date('2026-09-16T14:00:00+02:00'),
  },
];
